import { roundToMax2Decimals } from '@utils/number';

export const renderValueCell = <TRow extends { measureUnit: string }>(
  row: TRow,
  key: keyof TRow
) => {
  if (!row[key] && row[key] !== 0) {
    return '-';
  }
  return `${roundToMax2Decimals(row[key] as number)} ${row.measureUnit}`;
};
